import { KeyValue } from '@app/core/types/key-value.type'
import { isColumnVisible } from './is-column-visible.utils'
import { Preference } from '@app/core/model/user-preferences.interface'

export const countColumns = (columns: KeyValue<Preference> | Preference[]): number =>
  columns ? Object.values(columns).filter(isColumnVisible)?.length : 0
